import { render, staticRenderFns } from "./TestCall.vue?vue&type=template&id=7d33309e&scoped=true"
import script from "./TestCall.vue?vue&type=script&lang=js"
export * from "./TestCall.vue?vue&type=script&lang=js"
import style0 from "./TestCall.vue?vue&type=style&index=0&id=7d33309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33309e",
  null
  
)

export default component.exports